import { button } from '@groovehq/internal-design-system/lib/styles/elements'

export default function TagDropdownCreateButton({ onCreateTag }) {
  return (
    <button type="button" css={button.styles.link} onClick={onCreateTag}>
      + Create tag
    </button>
  )
}
